import { Commands } from '.';
var ChangeStatus = (function () {
    function ChangeStatus(data) {
        this.myId = data.Id;
        this.myMdiId = data.MdiId;
        this.myCloseable = data.Closeable || false;
        this.myKind = data.Kind || '';
        this.myMessage = data.Message;
        this.myTimeout = data.Timeout || 0;
    }
    Object.defineProperty(ChangeStatus.prototype, "id", {
        get: function () {
            return this.myId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "closeable", {
        get: function () {
            return this.myCloseable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "name", {
        get: function () {
            return Commands.ChangeStatusCommand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "kind", {
        get: function () {
            return this.myKind;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "message", {
        get: function () {
            return this.myMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "timeout", {
        get: function () {
            return this.myTimeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeStatus.prototype, "MDIId", {
        get: function () {
            return this.myMdiId;
        },
        enumerable: false,
        configurable: true
    });
    return ChangeStatus;
}());
export { ChangeStatus };
